import React from 'react';
import { Modal, message } from 'antd';
import COGSRuleForm from './COGSRuleForm';
import { cogsService } from '../services/cogsService';

const COGSCreationModal = ({
  visible,
  onCancel,
  onSuccess,
  title = "Create New COGS Rule",
  width = "90%",
  maxWidth = "1400px"
}) => {
  const handleSave = async (formData) => {
    try {
      // The COGSRuleForm in "create" mode works as follows:
      // - "Create Rule" button (htmlType="submit") triggers handleSubmit which calls onSave
      // - handleSubmit does NOT make API calls - it expects the parent to handle that
      //
      // So we need to make the API call here to actually create the rule.
      const createdRule = await cogsService.createRule(formData);

      if (createdRule && createdRule.id) {
        message.success('COGS rule created successfully!');

        // Close modal and notify parent
        onCancel();
        if (onSuccess) {
          onSuccess(createdRule, false);
        }
      } else {
        message.error('Failed to create COGS rule');
      }
    } catch (error) {
      message.error(error.message || 'Failed to create COGS rule');
    }
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={width}
      style={{ maxWidth }}
      destroyOnHidden={true}
    >
      <COGSRuleForm
        mode="create"
        onSave={handleSave}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default COGSCreationModal;
